import { render, staticRenderFns } from "./ShippingChargeAreaFeePopup.vue?vue&type=template&id=412ad1ae&scoped=true&"
import script from "./ShippingChargeAreaFeePopup.vue?vue&type=script&lang=ts&"
export * from "./ShippingChargeAreaFeePopup.vue?vue&type=script&lang=ts&"
import style0 from "./ShippingChargeAreaFeePopup.vue?vue&type=style&index=0&id=412ad1ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412ad1ae",
  null
  
)

export default component.exports